/**
 * Предикаты домена заказов. Чистые, без React и без транспорта.
 */

import { RestomenuError } from "@restomenu/core/client";

const UUID_RE =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

/**
 * Годен ли идентификатор заказа как адрес запроса.
 *
 * orderId приходит из URL и из сообщения хоста — то есть снаружи. Негодное
 * значение сервер отбил бы 400-м, но это мусор в интеграции, а не ошибка
 * пользователя: запрос не отправляем вовсе.
 */
export function isOrderId(value: string | null | undefined): value is string {
  return typeof value === "string" && UUID_RE.test(value);
}

/**
 * «Заказа нет ЛИБО он чужой» — ответы неразличимы намеренно, код один: 1329.
 *
 * Судим и по статусу, и по коду: путь есть не у всякой ошибки (MutationCache
 * зовёт reportError без ключа), а протухший идентификатор чаще обнаруживает
 * PATCH, чем чтение.
 */
export function isOrderNotFound(error: unknown): boolean {
  if (!(error instanceof RestomenuError)) return false;
  return error.status === 404 || error.errors.some((e) => e.code === 1329);
}
